import { Button } from "@/components/ui/button";
import { Notice } from "@/components/Notice";
import { useLang } from "@/features/onboarding/i18n";
import { formatDraftTime } from "./draft";

export function DraftRestoredNotice({ at, onStartOver, disabled = false }: { at: number; onStartOver: () => void; disabled?: boolean }) {
  const { t, locale } = useLang();
  return (
    <Notice tone="info" className="mb-4">
      {t("wiz.restored", { time: formatDraftTime(at, locale) })}{" "}
      <Button type="button" variant="link" onClick={onStartOver} disabled={disabled} className="h-auto p-0 align-baseline">
        {t("wiz.startOver")}
      </Button>
    </Notice>
  );
}
